/**
 * GameEffectSetStateType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file GameEffectSetStateType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum GameEffectSetStateType {
  CONFUSED = 1,
  FRIGHTENED = 2,
  DROID_STUN = 3,
  CUT_SCENE_STUNNED = 4,
  CUT_SCENE_PARALYZE = 5,
  SLEEP = 6,
  CHOKE = 7,
  CUT_SCENE_HORRIFIED = 8,
  FORCEPUSH = 9,
  WHIRLWIND = 10,
}